
import { Component, Emit, Prop } from 'vue-property-decorator'
import { AppCheckbox, AppInput, AppInputFile } from '@/components'
import { appAccountEntity} from '@/models/models'
import CommonForm from '@/mixins/CommonForm'
import { MediaType } from '@/utils/mediaType'
import '@/extensions/string'
import '@/extensions/Date'

@Component({
    components: {
        AppCheckbox,
        AppInput,
        AppInputFile,
    },
})
export default class DetailAndroidAccountForm extends CommonForm {
    @Prop() public value?: AppAccountEntity

    get account(): AppAccountEntity {
        return this.value ?? appAccountEntity
    }

    get mediaType(): MediaType {
        return MediaType.JSON
    }

    get showClientAccount(): boolean {
        return this.account!.androidType === 'CLIENT_ACCOUNT'
    }

    get apiKeyWasSubmitted(): boolean {
        return this.account!.apiKey != null && this.account!.apiKey.length > 0
    }

    @Emit('accountTypeChanged')
    public accountTypeChanged(event: any) {
        this.update(this.account, 'androidType', event)
        return event
    }

    @Emit('apiKeyChanged')
    public async apiKeyChanged(event: any) {
        if (event !== undefined && event !== '') {
            const text = await event[0].text()

            this.update(this.account, 'apiKey', text)
        }
        return event
    }
}
